import * as RechartsPrimitive from "recharts"

const ChartBar = RechartsPrimitive.Bar

export default ChartBar
